// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_3WrUw","hidden":"_28pAv","container":"_1wzOM","fillAllSpace":"_8mQh1","fullScreen":"JAMmD"};